define.alias("checkout/components/seamless-checkout-table/line-item", "settings/components/seamless-checkout-table/line-item");